import { Navigate, Route } from 'react-router-dom';

import { lazyImport } from 'utils/lazyImport';

const { AsyncStatus } = lazyImport(() => import('./AsyncStatus'), 'AsyncStatus');

export const asyncStatusRoutes = (
  <Route path="/">
    <Route index element={<AsyncStatus />} />
    <Route path="*" element={<Navigate to=".." replace />} />
  </Route>
);
